import { memo } from 'react'
import './NewAlertSwitchStatus.scss'
import classnames from 'classnames'
import { NO_TEXT, YES_TEXT } from '../../../../utils/constants'

const classNames = {
  checked: 'new-alert-form-all-visible-switch-checked',
  unchecked: 'new-alert-form-all-visible-switch-unchecked',
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const NewAlertSwitchStatus = memo(({ statusValue }) => (
  <div
    className={classnames('new-alert-form-all-visible-switch-text', {
      [classNames.checked]: statusValue === YES_TEXT,
      [classNames.unchecked]: statusValue === NO_TEXT,
    })}>
    {statusValue}
  </div>
))
